// extracted by mini-css-extract-plugin
export default {"root":"ways-to-help-card_root__HVAVg","paragraph":"ways-to-help-card_paragraph__5R+T6","credentials":"ways-to-help-card_credentials__s81gi","link":"ways-to-help-card_link__BFfJ3"};